import { Controller } from "@hotwired/stimulus"

// Unified recipe → grocery preview. The list shows every ingredient with a
// checkbox; this controller keeps the bottom CTA count in sync with what's
// checked and disables submit when nothing is selected. The form submits
// natively (the CTA is a submit button bound to the form), so there's no
// custom submit handling — checked ingredient_ids post straight through.
export default class extends Controller {
  static targets = ["checkbox", "submit", "count"]

  connect() {
    this.update()
  }

  update() {
    const checked = this.checkboxTargets.filter((c) => c.checked).length
    if (this.hasCountTarget) this.countTarget.textContent = checked
    if (this.hasSubmitTarget) this.submitTarget.disabled = checked === 0
  }
}
